<template>
  <div class="modal">
    <div class="modal-content">
      <slot></slot>
    </div>
    <div class="back" @click="close"></div>
  </div>
</template>

<script>

export default {
  name: 'Modal',

  methods: {
    clickHandler(e) {
      this.$emit('click', e)
    },
    close() {
      this.$emit('close')
    }
  }
}

</script>

<style scoped>
.modal {
  overflow: hidden;
  display: block;
  top: 0;
}

.back {
  position: absolute;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
}

.modal-content {
  background: #fff;
  border-radius: 5px;
  padding: 5px;
  width: 90vw;
  position: absolute;
  z-index: 11;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow: scroll;
  max-height: 95vh;
}

@media screen and (min-width: 800px){
  .modal-content {
    overflow: auto;
    max-width: 800px;
  }
}
</style>
